import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Globals } from '../globals';
import { FirestoreService } from './firestore/firestore.service';

export interface NewPrompterReport{
  id?: string;
  active?: boolean;
  createdAt?: Date;
  updatedAt?: Date;
  employeeId: string;
  employeeName: string;
  odpId: string;
  odpName: string;
  date: string;
  time: string;
  employees: NewPrompterReportEmployee[];
  userEmail: string;
}

export interface NewPrompterReportEmployee{
  id: string;
  name: string;
  shipId: string;
  shipName: string;
  activityId: string;
  activityName: string;
  time: string;
}

@Injectable()
export class NewPrompterReportService {

  collection: string = Globals.NEW_PROMPTER_REPORT_COLLECTION;

  constructor(
    private afh: FirestoreService,
    private router: Router,
  ) { }

  /**
   * Get all newPrompterReports with references
   * @return {Observable} Arrays of newPrompterReports
   */
  getNewPrompterReports({fromDate = ''} = {}): Observable<NewPrompterReport[]> {
    let col;
    if(fromDate){
      col = this.afh.colWithIds$(this.collection, ref => ref.where('active', '==', true).where('date', '==', fromDate) );
    }else{
      col = this.afh.colWithIds$(this.collection, ref => ref.where('active', '==', true) );
    }
    return col;
  }

  /**
  * Get newPrompterReport data
  * @param {string} sid - The id of the newPrompterReport
  * @return {Observable} The NewPrompterReport Object
  */
  getNewPrompterReport(sid: string): Observable<NewPrompterReport> {
    return this.afh.docWithIds$(`${this.collection}/${sid}`);
  }

  /**
  * Create new newPrompterReport
  * @param {NewPrompterReport} newPrompterReport - The data of the newPrompterReport
  */
  addNewPrompterReport(newPrompterReport: NewPrompterReport) {
    return this.afh.addPromise(`${this.collection}`, newPrompterReport);
  }

  /**
   * Update current newPrompterReport
   * @param {string} sid  - The id of the newPrompterReport
   * @param {NewPrompterReport} newPrompterReport - The data of the newPrompterReport
   */
  updateNewPrompterReport(sid: string, newPrompterReport: Partial<NewPrompterReport>) {
    return this.afh.update(`${this.collection}/${sid}`, newPrompterReport);
  }

  /**
   * Delete current newPrompterReport
   * @param {string} sid - The id of the newPrompterReport
   */
  deleteNewPrompterReport(sid: string) {
    this.afh.delete(`${this.collection}/${sid}`);
  }

  windowReplace = {
    add: () => this.router.navigate([`/add_newPrompterReport`]),
    read: () => this.router.navigate([`/newPrompterReport`]),
    edit: (id: string) => this.router.navigate([`/edt_newPrompterReport/${id}`]),
    view: (id: string) => this.router.navigate([`/vw_newPrompterReport/${id}`]),
  };
}
